<template>
  <div>
    <div class="loyalty-block-container relative z-10 mx-auto rounded bg-gray-50 text-center py-7 px-10 md:py-12">
      <h3 class="ota-h2 mb-3" v-html="$t('Loyalty.LoyaltyBlock.Title', { amount })" />
      <h4 class="ota-p14 mb-7 mx-auto" v-html="$t('Loyalty.LoyaltyBlock.Description', { amount })" />
      <div class="text-center mb-3">
        <OButton
          variant="secondary"
          @click="$router.push($i18n.localePath({ name: 'signup' }))"
        >
          {{ $t('Loyalty.LoyaltyBlock.StartNow') }}
        </OButton>
      </div>
      <span
        class="ota-p14"
        @click="$router.push($i18n.localePath({ name: 'loyalty' }))"
        v-html="$t('Loyalty.LoyaltyBlock.ReadMore', { link })"
      />
    </div>
  </div>
</template>

<script>
import OButton from '@/components/OButton'
import { addLocalCurrency } from '@/utils/general'

export default {
  name: 'LoyaltyBlock',
  components: {
    OButton
  },
  props: {
    country: {
      type: String,
      default: 'nl'
    },
    locale: {
      type: String,
      default: 'nl'
    }
  },
  computed: {
    link () {
      return `<span class="underline cursor-pointer">${this.$t('Loyalty.LoyaltyBlock.YourCredit')}</span>`
    },
    amount () {
      return `<span class="montserrat-currency">${addLocalCurrency(10, `${this.locale}-${this.country}`, 'EUR').replace(/\s/g, '').replace(',00', '').replace('.00', '')}</span>`
    }
  }
}
</script>

<style lang="postcss" scoped>
.loyalty-block-container {
  max-width: 127rem;
}

h4.ota-p14 {
  max-width: 60rem;
}
</style>
